import { Stagger, StaggerItem, Reveal } from "./motion";
import { PRISM } from "./data";

const CHAPTERS = [
  {
    n: "01",
    title: "You are met, not labelled",
    body:
      "Therapy begins with feeling safe. Before anything else, there is space to be heard without judgement, at a pace that belongs to you.",
  },
  {
    n: "02",
    title: "Understanding through your own lens",
    body:
      "Like light through a prism, every mind refracts the world differently. We work to understand your particular pattern — including neurodivergent ways of thinking and feeling.",
  },
  {
    n: "03",
    title: "Evidence, held gently",
    body:
      "The work is grounded in rigorous psychological science and behavioural analysis, but delivered with warmth, flexibility and genuine care.",
  },
  {
    n: "04",
    title: "Practical, lasting change",
    body:
      "We move toward clear, achievable steps — so that what you learn together continues to support you and your family long after our work ends.",
  },
];

export const Approach = () => (
  <section
    id="approach"
    data-testid="approach-section"
    className="relative bg-prism-sand/50 border-y border-border grain overflow-hidden"
  >
    <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-10 py-28 lg:py-40">
      <Reveal>
        <p
          className="inline-flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.28em] mb-5"
          style={{ color: "hsl(var(--muted-foreground))" }}
        >
          <span className="h-1.5 w-6 rounded-full prism-line" /> The approach
        </p>
        <h2 className="font-serif font-light tracking-tight leading-tight text-primary text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
          A philosophy of gentle, deliberate care
        </h2>
      </Reveal>

      <Stagger className="mt-20 space-y-2">
        {CHAPTERS.map((c, i) => (
          <StaggerItem key={c.n}>
            <div
              data-testid={`chapter-${c.n}`}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start py-10 border-t border-border"
            >
              <div className="md:col-span-3">
                <span
                  className="font-serif text-7xl lg:text-8xl font-extralight leading-none opacity-70 group-hover:opacity-100 transition-opacity duration-500"
                  style={{ color: PRISM[i % PRISM.length] }}
                >
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-4 font-serif text-2xl lg:text-3xl font-light tracking-tight text-primary">
                {c.title}
              </h3>
              <p
                className="md:col-span-5 text-base lg:text-lg font-light leading-relaxed"
                style={{ color: "hsl(var(--muted-foreground))" }}
              >
                {c.body}
              </p>
            </div>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  </section>
);
